module.exports = __webpack_public_path__ + "static/media/PointsV2.6fc15597.png";